import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Input, Tooltip, Form, Modal, Select, Space } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, BarsOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const EleicoesCipaCadLocalidades = ({ to }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    listarLocalidades();
  }, []);

  // LISTAR
  const listarLocalidades = async () => {
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_localidades/listar`, []);
    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarLocalidade = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_localidades/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "ADD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarLocalidade = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_localidades/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarLocalidade = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_localidades/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarLocalidade = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_localidades/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      dispatch({ type: "DELETE", payload: { id: id } });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Filiais">
            <Button
              loading={loading}
              onClick={() => navigate(`/eleicoes-cipa/localidades/filiais/${e?.id}`)}
              icon={<BarsOutlined />}
            />
          </Tooltip>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarLocalidade(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarLocalidade(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarLocalidade(formulario);
    } else {
      cadastrarLocalidade(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Localidade
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={600}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item name="descricao" label="Descrição" rules={[{ required: true, message: "Digite a descrição!" }]}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={24}>
            <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title="Localidades"
              subtitle="Cadastro de Localidades"
              icon={<EnvironmentOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
